import axios from 'axios';
import moment from 'moment';
import ErrorLogger from '../utils/errorLogger';

export const API_URL = process.env.REACT_APP_API_URL;
export const API_URL_LOCAL_TERMINAL = process.env.REACT_APP_API_URL_LOCAL_TERMINAL;

const attachConfig = (config) => {
    return {
        ...config,
    }
};

const emptyStringToNull = (data) => {
    let d = { ...data };

    for (let key in d) {
        if (d.hasOwnProperty(key) && d[key] === '') {
            d[key] = null;
        }
    }

    return d;
};

class Api {
    get(endpoint, config) {
        const q = axios.get(API_URL + endpoint, attachConfig(config));
        q.catch(err => this.handleError(err, 'GET', endpoint, config));
        return q;
    }

    post(endpoint, data, config) {
        const q = axios.post(API_URL + endpoint, emptyStringToNull(data), attachConfig(config));
        q.catch(err => this.handleError(err, 'POST', endpoint, data, config));
        return q;
    }

    put(endpoint, data, config) {
        const q = axios.put(API_URL + endpoint, emptyStringToNull(data), attachConfig(config));
        q.catch(err => this.handleError(err, 'PUT', endpoint, data, config));
        return q;
    }

    patch(endpoint, data, config) {
        const q = axios.patch(API_URL + endpoint, emptyStringToNull(data), attachConfig(config));
        q.catch(err => this.handleError(err, 'PATCH', endpoint, data, config));
        return q;
    }

    delete(endpoint, config) {
        const q = axios.delete(API_URL + endpoint, attachConfig(config));
        q.catch(err => this.handleError(err, 'DELETE', endpoint, config));
        return q;
    }

    getLocal(endpoint, config) {
        const q = axios.get(API_URL_LOCAL_TERMINAL + endpoint, attachConfig(config));
        q.catch(err => this.handleError(err, 'GET', endpoint, config, true));
        return q;
    }
    getLocalNoSentry(endpoint, config) {
        const q = axios.get(API_URL_LOCAL_TERMINAL + endpoint, attachConfig(config));
        q.catch(err => console.error('API Error:', err));
        return q;
    }

    postLocal(endpoint, data, config) {
        const q = axios.post(API_URL_LOCAL_TERMINAL + endpoint, emptyStringToNull(data), attachConfig(config));
        q.catch(err => this.handleError(err, 'POST', endpoint, data, config, true));
        return q;
    }

    handleError(err, method, endpoint, data = null, config = null, isLocal = false) {
        if (axios.isCancel(err)) {
            // Don't do anything if request was cancelled
            return;
        }

        // Log to console for development
        console.error('API Error:', err);

        // Log to Sentry
        ErrorLogger.logApiError(err, {
            endpoint,
            method,
            requestData: data,
            responseData: err.response?.data,
            isLocal,
            statusCode: err.response?.status,
            statusText: err.response?.statusText,
            extra: {
                config,
                url: err.config?.url,
                headers: err.config?.headers
            }
        });

        // Handle 401 errors specifically
        this.handle401(err);
    }

    handle401(err) {
        if (err.response?.status === 401) {
            // Log unauthorized access
            ErrorLogger.logMessage('Unauthorized API access', 'warning', {
                component: 'api',
                action: 'unauthorized_access',
                extra: {
                    url: err.config?.url,
                    method: err.config?.method
                }
            });

            // TODO: handle 401 errors, maybe show message or redirect to login?
        }
    }
}

export default new Api();

export const formatDate = (date) => {
    return moment(date).format('YYYY-MM-DD');
};
